{
  "FILTER": {
    "AI_PROMPT": "AI szűrő",
    "TITLE": "Beszélgetések szűrése",
    "SUBTITLE": "Adja hozzá a szűrőket az alábbiakban, és nyomja meg a \"Szűrők alkalmazása\" gombot.",
    "EDIT_CUSTOM_FILTER": "Mappa szerkesztése",
    "CUSTOM_VIEWS_SUBTITLE": "Adj hozzá vagy törölj szűrőket, és frissítsd a mappát.",
    "ADD_NEW_FILTER": "Szűrő hozzáadása",
    "FILTER_DELETE_ERROR": "Hoppá, úgy tűnik, semmit sem tudunk elmenteni! Kérjük, adjon hozzá legalább egy szűrőt a mentéshez.",
    "SUBMIT_BUTTON_LABEL": "Szűrők alkalmazása",
    "UPDATE_BUTTON_LABEL": "Mappa frissítése",
    "CANCEL_BUTTON_LABEL": "Mégse",
    "CLEAR_BUTTON_LABEL": "Szűrők törlése",
    "FOLDER_LABEL": "Mappa neve",
    "TEAMS_LABEL": "Megosztás vele",
    "PARENT_FOLDER_LABEL": "Szülő mappa",
    "NO_PARENT_FOLDER": "Nincs szülő mappa",
    "BACKGROUND_COLOR_LABEL": "Háttérszín",
    "COLOR_LABEL": "Szín",
    "SELECT_COLOR": "Szín kiválasztása",
    "CLEAR_SELECTION": "Kijelölés törlése",
    "SORT_BY_LABEL": "Rendezés",
    "FOLDER_QUERY_LABEL": "Mappa lekérdezés",
    "EMPTY_VALUE_ERROR": "Kötelező megadni.",
    "TOOLTIP_LABEL": "Beszélgetések szűrése",
    "QUERY_DROPDOWN_LABELS": {
      "AND": "ÉS",
      "OR": "VAGY"
    },
    "INPUT_PLACEHOLDER": "Adja meg az értéket",
    "OPERATOR_LABELS": {
      "present": "Jelen van",
      "not_present": "Nincs jelen",
      "present_with_answer": "Jelen van válasszal",
      "present_without_answer": "Jelen van válasz nélkül",
      "equal_to": "Egyenlő",
      "not_equal_to": "Nem egyenlő",
      "does_not_contain": "Nem tartalmaz",
      "is_present": "Jelen van",
      "is_not_present": "Nincs jelen",
      "is_greater_than": "Nagyobb",
      "is_less_than": "Kisebb",
      "is_greater_than_or_equal": "Nagyobb vagy egyenlő",
      "is_less_than_or_equal": "Kisebb vagy egyenlő",
      "newer_than_days": "Újabb mint x nap (beleértve)",
      "older_than_days": "Régebbi mint x nap (beleértve)",
      "starts_with": "Ezzel kezdődik",
      "equalTo": "Egyenlő",
      "notEqualTo": "Nem egyenlő",
      "contains": "Tartalmaz",
      "doesNotContain": "Nem tartalmaz",
      "isPresent": "Jelen van",
      "isNotPresent": "Nincs jelen",
      "isGreaterThan": "Nagyobb",
      "isLessThan": "Kisebb mint",
      "isGreaterThanOrEqual": "Nagyobb vagy egyenlő",
      "isLessThanOrEqual": "Kisebb vagy egyenlő",
      "startsWith": "Ezzel kezdődik"
    },
    "ATTRIBUTE_LABELS": {
      "TRUE": "Igaz",
      "FALSE": "Hamis"
    },
    "ATTRIBUTES": {
      "STATUS": "Státusz",
      "ASSIGNEE_NAME": "Jogosult neve",
      "INBOX_NAME": "Fiók név",
      "TEAM_NAME": "Csapatnév",
      "CONVERSATION_IDENTIFIER": "Beszélgetés azonosítója",
      "CAMPAIGN_NAME": "Vállalkozás neve",
      "LABELS": "Cimkék",
      "BROWSER_LANGUAGE": "Böngésző nyelve",
      "PRIORITY": "Prioritás",
      "COUNTRY_NAME": "Ország neve",
      "REFERER_LINK": "Hivatkozás link",
      "CUSTOM_ATTRIBUTE_LIST": "Lista",
      "CUSTOM_ATTRIBUTE_TEXT": "Szöveg",
      "CUSTOM_ATTRIBUTE_NUMBER": "Szám",
      "CUSTOM_ATTRIBUTE_LINK": "Link",
      "CUSTOM_ATTRIBUTE_CHECKBOX": "Jelölőnégyzet",
      "CREATED_AT": "Létrehozva",
      "LAST_ACTIVITY": "Utolsó aktivitás",
      "LAST_CUSTOMER_MESSAGE_AT": "Utolsó ügyfélüzenet",
      "PHONE_CALL": "Telefonhívás",
      "RATING": "Értékelés",
      "CSAT": "CSAT"
    },
    "PHONE_CALL_TYPES": {
      "INBOUND": "Bejövő",
      "OUTBOUND": "Kimenő",
      "MISSED": "Nem fogadott",
      "UNHANDLED_MISSED": "Kezeletlen nem fogadott"
    },
    "RATING_TYPES": {
      "UP": "Tetszik",
      "DOWN": "Nem tetszik"
    },
    "ERRORS": {
      "VALUE_REQUIRED": "Kötelező megadni",
      "ATTRIBUTE_KEY_REQUIRED": "A tulajdonság kulcsa kötelező",
      "FILTER_OPERATOR_REQUIRED": "A szűrő operátora kötelező",
      "VALUE_MUST_BE_BETWEEN_0_AND_998": "Az értéknek 0 és 998 között kell lennie",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "Value must be between 1 and 998"
    },
    "GROUPS": {
      "STANDARD_FILTERS": "Standard szűrők",
      "ADDITIONAL_FILTERS": "További szűrők",
      "CUSTOM_ATTRIBUTES": "Egyéni tulajdonságok"
    },
    "CUSTOM_VIEWS": {
      "ADD": {
        "TITLE": "El akarod menteni ezt a szűrőt?",
        "LABEL": "Nevezd el a szűrőt",
        "PLACEHOLDER": "Nevezze el a szűrőt, hogy később hivatkozhasson rá.",
        "ERROR_MESSAGE": "Név kötelező.",
        "SAVE_BUTTON": "Szűrő mentése",
        "CANCEL_BUTTON": "Mégse",
        "API_FOLDERS": {
          "SUCCESS_MESSAGE": "Mappa sikeresen létrehozva.",
          "ERROR_MESSAGE": "Hiba történt a mappa létrehozása során."
        },
        "API_SEGMENTS": {
          "SUCCESS_MESSAGE": "Szegmens sikeresen létrehozva.",
          "ERROR_MESSAGE": "Hiba történt a szegmens törlésekor."
        }
      },
      "EDIT": {
        "EDIT_BUTTON": "Mappa szerkesztése",
        "API_FOLDERS": {
          "ERROR_MESSAGE": "Hiba történt a mappa frissítése során."
        }
      },
      "DELETE": {
        "DELETE_BUTTON": "Szűrő törlése",
        "MODAL": {
          "CONFIRM": {
            "TITLE": "Törlés megerősítése",
            "MESSAGE": "Biztosan törölni akarod a szűrőt ",
            "YES": "Igen, törlés",
            "NO": "Nem, tartsd meg"
          }
        },
        "API_FOLDERS": {
          "SUCCESS_MESSAGE": "Mappa sikeresen törölve.",
          "ERROR_MESSAGE": "Hiba történt a mappa törlése során."
        },
        "API_SEGMENTS": {
          "SUCCESS_MESSAGE": "Szegmens törölve.",
          "ERROR_MESSAGE": "Hiba történt a szegmens törlése során."
        }
      }
    }
  }
}
